// extracted by mini-css-extract-plugin
export default {"menuItems":"aife-menu_menuItems__6eLl9","stretch":"aife-menu_stretch__iQYfr"};